import React, { useState, useEffect } from "react";
import { colors } from "../../../../../../themes/Colors";
import {
  BaseButtons,
  CheckInput,
  TextInputField,
} from "../../../../../common-components";

const AddAgentPopUpDisplay = ({
  display,
  setAddAgentPopUp,
  companyInformation,
  setLoading,
  setMessage,
  setToastPop,
  setPopUpTitle,
  auth,
  setRefresh,
  refresh,
}) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [cellNumber, setCellNumber] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [team, setTeam] = useState("");
  const [type, setType] = useState("");
  const [permissions, setPermissions] = useState("");

  const ClearData = () => {
    setFirstName("");
    setLastName("");
    setCellNumber("");
    setEmail("");
    setPassword("");
    setConfirmPassword("");
    setTeam("");
    setType("");
    setPermissions("");
  };

  const createNewAgent = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/agency/createNewAgentFromAdmin",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: auth.userId,
            firstName,
            lastName,
            cellNumber,
            email,
            password,
            companyId: auth.companyId,
            team: team.toLocaleUpperCase(),
            type,
            permissions: [permissions],
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setAddAgentPopUp(false);
        ClearData();
        setRefresh(refresh ? false : true);
        setToastPop(true);
        setPopUpTitle("SUCCESS");
        setMessage(respnseData.success);
        setLoading(false);

        // setToastPop(true);
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage(respnseData.message);
        setToastPop(true);
      }
    } catch (err) {
      setLoading(false);
      setMessage(
        "No network, contact support if you have a data connectin and are still unable to connect"
      );
      setToastPop(true);
      console.log("error", err);
    }
  };
  // userId,

  return (
    <div
      style={{
        position: "absolute",
        bottom: 0,
        backgroundColor: colors.white,
        overflow: "hidden",
        height: display ? "100%" : 0,
        width: "100%",
        transition: "all 0.2s",
        display: "flex",
      }}
    >
      <div
        style={{
          top: 20,
          left: 20,
          position: "absolute",
          display: "flex",
          alignItems: "center",
        }}
      >
        <BaseButtons
          label={"BACK"}
          backgroundColor={colors.orangeDark}
          borderRadius={8}
          width={120}
          onClick={() => setAddAgentPopUp(false)}
        />
        <div style={{ marginLeft: 20, fontWeight: "bold" }}>ADD NEW AGENT</div>
      </div>
      <div
        style={{
          top: 20,
          right: 20,
          position: "absolute",
          display: "flex",
          alignItems: "center",
        }}
      >
        <BaseButtons
          label={"SAVE NEW AGENT"}
          backgroundColor={colors.secondaryDarkBlue}
          borderRadius={8}
          width={160}
          disabled={
            password !== "" &&
            confirmPassword !== "" &&
            password === confirmPassword
              ? false
              : true
          }
          onClick={() => {
            createNewAgent();
          }}
        />
      </div>
      <div style={{ flex: 1, display: "flex" }}>
        <div
          style={{
            flex: 0.5,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ minHeight: 80 }} />
          <TextInputField
            mini={true}
            labelTitle={"First name"}
            size={"85%"}
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
          <div style={{ minHeight: 5 }} />
          <TextInputField
            mini={true}
            labelTitle={"Last name"}
            size={"85%"}
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
          <div style={{ minHeight: 5 }} />
          <TextInputField
            mini={true}
            labelTitle={"cell number"}
            size={"85%"}
            value={cellNumber}
            onChange={(e) => setCellNumber(e.target.value)}
          />
          <div style={{ minHeight: 5 }} />
          <TextInputField
            mini={true}
            labelTitle={"Email"}
            size={"85%"}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <div style={{ minHeight: 5 }} />
          <TextInputField
            mini={true}
            labelTitle={"Password"}
            size={"85%"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <div style={{ minHeight: 5 }} />
          <TextInputField
            mini={true}
            labelTitle={"Confirm Password"}
            size={"85%"}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>
        <div
          style={{
            flex: 0.5,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div style={{ minHeight: 80 }} />
          <div
            style={{
              width: "85%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                fontSize: 16,
                fontWeight: "bold",
                marginTop: 15,
                marginBottom: 15,
              }}
            >
              Teams
            </div>
            <CheckInput
              label={"Fines"}
              selected={team === "fines"}
              onClick={() => setTeam("fines")}
            />
            <CheckInput
              label={"Lisensing"}
              selected={team === "lisensing"}
              onClick={() => setTeam("lisensing")}
            />
            <CheckInput
              label={"Sales"}
              selected={team === "sales"}
              onClick={() => setTeam("sales")}
            />
            <CheckInput
              label={"Valuation"}
              selected={team === "valuation"}
              onClick={() => setTeam("valuation")}
            />
            <CheckInput
              label={"Auto-fitment"}
              selected={team === "auto-fitment"}
              onClick={() => setTeam("auto-fitment")}
            />
            <CheckInput
              label={"Services"}
              selected={team === "services"}
              onClick={() => setTeam("services")}
            />
            <CheckInput
              label={"Spares"}
              selected={team === "spares"}
              onClick={() => setTeam("spares")}
            />
            <CheckInput
              label={"Towing"}
              selected={team === "towing"}
              onClick={() => setTeam("towing")}
            />
          </div>

          <div
            style={{
              width: "85%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                fontSize: 16,
                fontWeight: "bold",
                marginTop: 15,
                marginBottom: 15,
              }}
            >
              Type
            </div>
            <CheckInput
              label={"ADMIN"}
              selected={type === "ADMIN"}
              onClick={() => setType("ADMIN")}
            />
            <CheckInput
              label={"TEAM LEADER"}
              selected={type === "TEAM LEADER"}
              onClick={() => setType("TEAM LEADER")}
            />
            <CheckInput
              label={"AGENT"}
              selected={type === "AGENT"}
              onClick={() => setType("AGENT")}
            />
          </div>
          <div
            style={{
              width: "85%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                fontSize: 16,
                fontWeight: "bold",
                marginTop: 15,
                marginBottom: 15,
              }}
            >
              Permissions
            </div>
            <CheckInput
              label={"ALL"}
              selected={permissions === "ALL"}
              onClick={() => setPermissions("ALL")}
            />
            <CheckInput
              label={"IN-ACTIVE"}
              selected={permissions === "IN-ACTIVE"}
              onClick={() => setPermissions("IN-ACTIVE")}
            />
            <CheckInput
              label={"DISABLED"}
              selected={permissions === "DISABLED"}
              onClick={() => setPermissions("DISABLED")}
            />
            <CheckInput
              label={"ACTIVE"}
              selected={permissions === "ACTIVE"}
              onClick={() => setPermissions("ACTIVE")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAgentPopUpDisplay;
